import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { withRouter } from 'react-router-dom';

import { WEB_URL, PUBLIC_IMG_URL } from '../../../lib/endpoints';
import { ALLOWED_QUERY_OPERATOR, DEF_MAGNITT_DESCRIPTION } from '/src/lib/constants';
import { prepareFilterParam, prepareSortParam } from '../../../../src/lib/queryParams';
import { handleRedirectMessage } from '../../Reusable/toast';
import { withBootstrapPlugin } from '/src/lib/helpers';
import researchApi from '../../../apis/researchApi';

import LandingBanner from './LandingBanner/LandingBanner';
import Features     from './Features/Features';
import Stats        from './Stats/Stats';
import TrustedBy    from './TrustedBy/TrustedBy';
import Ecosystem    from './Ecosystem/Ecosystem';
import Research     from './Research/Research';
import Testimonials from './Testimonials/Testimonials';
import CallToAction from './CallToAction/CallToAction';

function LandingPage({ location }) {
    const [researchReports, setResearchReports] = useState([]);

    useEffect(() => {
        const filters = prepareFilterParam([{ key: 'is_published', value: [1], op: ALLOWED_QUERY_OPERATOR.equal }]);
        const sort    = prepareSortParam([{ key: 'published_at', sortVal: 'desc' }]);

        researchApi.getResearchData(filters, 3, 1, sort).then(response => {
            if (!response.records) return;
            const reports = response.records.map(item => ({
                ...item,
                published_at: item.published_at
                    ? new Date(item.published_at).toLocaleString('en-US', { month: 'long', year: 'numeric' })
                    : null,
                displayPrice: item.type_id === 1
                    ? (item.price > 0 ? `$${item.price}` : 'Premium')
                    : 'FREE',
            }));
            setResearchReports(reports);
        });

        handleRedirectMessage(location);
    }, []);

    const showContactSales = () => {
        withBootstrapPlugin('modal', ($) => $('#contactFormModal').modal('show'));
    };

    return (
        <div className="footer-margin-offset home-landing-page">
            <Helmet
                title="Home | MAGNiTT"
                link={[
                    { rel: 'canonical',  href: WEB_URL },
                    { rel: 'preconnect', href: PUBLIC_IMG_URL },
                    { rel: 'preload', href: `${PUBLIC_IMG_URL}/homepage/home_banner.avif`, as: 'image', fetchpriority: 'high' },
                ]}
                meta={[
                    { name: 'description',  content: DEF_MAGNITT_DESCRIPTION },
                    { name: 'abstract',     content: DEF_MAGNITT_DESCRIPTION },
                    { property: 'og:type',  content: 'article' },
                    { property: 'og:url',   content: 'https://magnitt.com' },
                    { property: 'og:title', content: 'Home | MAGNiTT' },
                ]}
                script={[{
                    type: 'application/ld+json',
                    innerHTML: `{
                        "@context": "http://schema.org",
                        "@type": "BreadcrumbList",
                        "itemListElement": [{ "@type": "ListItem", "position": 1, "name": "home", "item": "${WEB_URL}" }]
                    }`
                }]}
            />

            <LandingBanner showContactSales={showContactSales} />
            <Features     />
            <Stats        />
            <TrustedBy    />
            <Ecosystem    />
            <Research     reports={researchReports} />
            <Testimonials />
            <CallToAction showContactSales={showContactSales} />
        </div>
    );
}

export default withRouter(LandingPage);
